export const environment = {
  production: false,
  apiUrl: 'https://4v7o55f0c6.execute-api.us-east-1.amazonaws.com/dev',
  authEndpoint: 'https://mes-dev.auth.us-east-1.amazoncognito.com/oauth2/',
  clientId: '37u26r83t8p60ungksst5kdlf1',
  redirectUri: 'https://dev.gptadmin.slalom.com',
  showFeatureBranchExplorer: true,
  showPersona: true,
  showEnvironmentBanner: true,
  environmentName: 'DEVELOPMENT',
  environmentBannerColor: 'info' as const,
};
